



















































































import { Vue, Component, Watch } from 'vue-property-decorator'
import CatalogHeader from '@/modules/catalog/components/CatalogHeader'
import TournamentCatalogItem, {
  TournamentGameTypeOption
} from '@/modules/catalog/components/TournamentCatalogItem'
import {
  TournamentGameType,
  TournamentEntity,
  TournamentState,
  TournamentAPI
} from '@/api/tournament'
import { getElementScrollRemaining } from '@/utils/window'
import tournamentStore from '@/modules/tournament/tournament.store'
import { getModule } from 'vuex-module-decorators'
import ServerError from '@/utils/server_error'
import { getGameTypes } from '@/utils/gameType'

@Component({
  components: {
    CatalogHeader,
    TournamentCatalogItem
  }
})
export default class InstantMatchPastTournament extends Vue {
  // Page configuration
  title: string = 'Past Tournaments'
  tournamentState: TournamentState[] = [
    TournamentState.OpenRegistration,
    TournamentState.CompleteRegistration,
    TournamentState.InProgress
  ]

  // Filters
  gameFilter: TournamentGameType = TournamentGameType.All
  tournamentModule = getModule(tournamentStore, this.$store)
  tournaments: TournamentEntity[] = []
  isInitializing: boolean = true
  isLoading: boolean = false
  loading: boolean = false
  hasMorePage: boolean = true
  currentPage: number = 0
  searchFilter: any = {}

  async scrollBehavior(event: Event) {
    if (
      getElementScrollRemaining(event.target as HTMLElement) <= 50 &&
      this.hasMorePage &&
      !this.isLoading
    ) {
      await this.fetchMoreTournamentCatalog()
    }
  }

  async fetchTournamentCatalog() {
    try {
      // Set filter

      this.isLoading = true
      this.searchFilter = {
        game: this.gameFilter
      }
      await this.fetchTournament()
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('AppSwiper.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.isLoading = false
      this.isInitializing = false
    }
  }
  async fetchTournament(page: number = 1) {
    if (page <= this.currentPage || !this.hasMorePage || this.loading) {
      return
    }
    this.currentPage = page
    this.loading = true
    try {
      const response = await TournamentAPI.getInstantMatchPastTournaments(
        page,
        this.searchFilter
      )
      const payload = response.data.payload
      if (payload) {
        this.hasMorePage = payload.hasMorePage
        this.tournaments = [...this.tournaments, ...payload.items]
      }
    } catch {
    } finally {
      this.loading = false
    }
  }

  async fetchMoreTournamentCatalog() {
    try {
      await this.fetchTournament(this.currentPage + 1)
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('AppSwiper.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  /* Wathcers */
  @Watch('gameFilter')
  async onGameFilterChanged(game: TournamentGameType) {
    await this.fetchTournamentCatalog()
  }

  /* Hooks */
  async created() {
    this.title = this.$t('PastTournamentCatalog.Title')
    await this.fetchTournamentCatalog()
  }

  get games(): TournamentGameTypeOption[] {
    const gameTypes = getGameTypes()
    var games = [
      {
        text: this.$t('TournamentHistory.AllGames'),
        value: TournamentGameType.All
      }
    ]
    gameTypes.map(gameType => {
      games.push({
        text: gameType.name,
        value: gameType.code as TournamentGameType
      })
    })
    return games
  }
}
